// extracted by mini-css-extract-plugin
export var cardIcon = "_68-5";
export var checkboxCard = "_68-0";
export var checkboxCardSelected = "_68-4";
export var disabled = "_68-2";
export var interactive = "_68-1";
export var outerBorder = "_68-3";
export var spacerMedium = "_68-8";
export var spacerSmall = "_68-7";
export var spacerXsmall = "_68-6";